export default apiFetch => async payload => {
  const response = await apiFetch({
    endpoint: "tweets",
    method: "get",
    body: null
  });

  return await response.json();
};
